export enum ReportDatePreset {
    TODAY = 'today',
    YESTERDAY = 'yesterday',
    LAST_7_DAYS = 'last_7_days',
    LAST_14_DAYS = 'last_14_days',
    LAST_30_DAYS = 'last_30_days',
    LAST_45_DAYS = 'last_45_days',
    LAST_90_DAYS = 'last_90_days',
    THIS_MONTH = 'this_month',
    LAST_MONTH = 'last_month',
    THIS_YEAR = 'this_year',
    LAST_YEAR = 'last_year',
    LIFETIME = 'lifetime',
}
